import { Action, createReducer, on } from '@ngrx/store';
import { Product } from '../models/manage-offerings.model';
import * as actions from '../actions';

export const getManageOfferingsFeatureKey = 'getManageOfferings';

export interface ManageOfferingsState {
  loadSolutionsResponse: Product[];
  loadSolutionsResponseFailure: any;
  loaded: boolean;
}

export const initialState: ManageOfferingsState = {
  loadSolutionsResponse: undefined,
  loadSolutionsResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadManageOfferings, (state, action) => ({
    ...state
  })),
  on(actions.loadManageOfferingsSuccess, (state, action) => ({
    ...state,
    loadSolutionsResponse: action.response,
    loaded: true
  })),

  on(actions.loadManageOfferingsFailure, (state, action) => ({
    ...state,
    loadSolutionsResponseFailure: action.error
  })),
  on(actions.loadClearManageOfferings, (state, action) => ({
    ...state,
    loadSolutionsResponse: undefined,
    loaded: false
  }))
);

export const getManageOfferingsResponse = (state: ManageOfferingsState) => {
  if (state.loadSolutionsResponse) {
    let newArr = JSON.parse(JSON.stringify(state.loadSolutionsResponse));
    return newArr;
  } else {
    return [];
  }
};

export const getManageOfferingsIsLoaded = (state: ManageOfferingsState) => state.loaded;
